import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersKpiTermsMutateType } from "~/domains";

type RequestDataType = {
  id: string;
  body: {
    businessSectionId: string;
    title: string;
    fromDate: string;
    toDate: string;
    publicStatusId: number;
  };
};

const request = ({ id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ApiManagersKpiTermsMutateType>(`/api/managers/kpi_terms/${id}`, {
      kpiTerm: body,
    })
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersKpiTermsUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersKpiTermsMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
